/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskBusinessName } from './ExecRiskBusinessName';
import {
    ExecRiskBusinessNameFromJSON,
    ExecRiskBusinessNameFromJSONTyped,
    ExecRiskBusinessNameToJSON,
} from './ExecRiskBusinessName';

/**
 * 
 * @export
 * @interface ExecRiskOfficerDirectorTrusteeEmpl
 */
export interface ExecRiskOfficerDirectorTrusteeEmpl {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskOfficerDirectorTrusteeEmpl
     */
    person_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskOfficerDirectorTrusteeEmpl
     */
    title_txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskOfficerDirectorTrusteeEmpl
     */
    average_hrs_per_wk_devoted_to_pos_rt?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskOfficerDirectorTrusteeEmpl
     */
    compensation_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskOfficerDirectorTrusteeEmpl
     */
    employee_benefit_program_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskOfficerDirectorTrusteeEmpl
     */
    expense_account_other_allwnc_amt?: number;
    /**
     * 
     * @type {ExecRiskBusinessName}
     * @memberof ExecRiskOfficerDirectorTrusteeEmpl
     */
    business_name?: ExecRiskBusinessName;
}

/**
 * Check if a given object implements the ExecRiskOfficerDirectorTrusteeEmpl interface.
 */
export function instanceOfExecRiskOfficerDirectorTrusteeEmpl(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskOfficerDirectorTrusteeEmplFromJSON(json: any): ExecRiskOfficerDirectorTrusteeEmpl {
    return ExecRiskOfficerDirectorTrusteeEmplFromJSONTyped(json, false);
}

export function ExecRiskOfficerDirectorTrusteeEmplFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskOfficerDirectorTrusteeEmpl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'person_name': !exists(json, 'person_name') ? undefined : json['person_name'],
        'title_txt': !exists(json, 'title_txt') ? undefined : json['title_txt'],
        'average_hrs_per_wk_devoted_to_pos_rt': !exists(json, 'average_hrs_per_wk_devoted_to_pos_rt') ? undefined : json['average_hrs_per_wk_devoted_to_pos_rt'],
        'compensation_amt': !exists(json, 'compensation_amt') ? undefined : json['compensation_amt'],
        'employee_benefit_program_amt': !exists(json, 'employee_benefit_program_amt') ? undefined : json['employee_benefit_program_amt'],
        'expense_account_other_allwnc_amt': !exists(json, 'expense_account_other_allwnc_amt') ? undefined : json['expense_account_other_allwnc_amt'],
        'business_name': !exists(json, 'business_name') ? undefined : ExecRiskBusinessNameFromJSON(json['business_name']),
    };
}

export function ExecRiskOfficerDirectorTrusteeEmplToJSON(value?: ExecRiskOfficerDirectorTrusteeEmpl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'person_name': value.person_name,
        'title_txt': value.title_txt,
        'average_hrs_per_wk_devoted_to_pos_rt': value.average_hrs_per_wk_devoted_to_pos_rt,
        'compensation_amt': value.compensation_amt,
        'employee_benefit_program_amt': value.employee_benefit_program_amt,
        'expense_account_other_allwnc_amt': value.expense_account_other_allwnc_amt,
        'business_name': ExecRiskBusinessNameToJSON(value.business_name),
    };
}

